var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.295,
    height: 16.295,
    viewBox: "0 0 16.295 16.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49724",
    "data-name": "Group 49724",
    transform: "translate(-803.005 -483.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94618",
    "data-name": "Path 94618",
    d: "M-.485-.485A.905.905,0,0,0-.485.8l6.6,6.6L-.485,14A.905.905,0,0,0,.8,15.28L8.038,8.038a.905.905,0,0,0,0-1.28L.8-.485A.905.905,0,0,0-.485-.485Z",
    transform: "translate(803.755 484.651)",
    fill: "#193238",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94619",
    "data-name": "Path 94619",
    d: "M-.485-.485A.905.905,0,0,0-.485.8l6.6,6.6L-.485,14A.905.905,0,0,0,.8,15.28L8.038,8.038a.905.905,0,0,0,0-1.28L.8-.485A.905.905,0,0,0-.485-.485Z",
    transform: "translate(810.997 484.651)",
    fill: "#193238",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.55922208f3b6a012be4d33b10f7647e9.svg";
export { ForwardRef as ReactComponent };